if (!customElements.get('tab-mega-menu')) {
  class MegaMenuTab extends HTMLElement {
    constructor() {
      super();
      this.tabMenu = Array.from(this.querySelectorAll('[tab-menu]'));
      this.tabContent = Array.from(this.querySelectorAll('[tab-content]'));
      this._onTabActivate = this._onTabActivate.bind(this);
    }

    connectedCallback() {
      if (!this.tabMenu.length) return;

      this.tabMenu.forEach((tab, index) => {
        // HOVER: prepne pravý panel (bez navigácie)
        tab.addEventListener('mouseenter', () => {
          this._onTabActivate(index);
        });

        // CLICK: iba ak je to "fake" klik (z JS), zablokuj navigáciu.
        // Reálny klik od človeka nech normálne naviguje podľa href.
        tab.addEventListener('click', (e) => {
          if (e.isTrusted === false) {
            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
            this._onTabActivate(index);
          }
          // else: user klikol -> nechaj href fungovať
        });
      });
    }

    _onTabActivate(activeIndex) {
      this.tabMenu.forEach((tab, idx) => {
        tab.classList.toggle('active', idx === activeIndex);
      });
      this.tabContent.forEach((content, idx) => {
        content.classList.toggle('active', idx === activeIndex);
      });
    }
  }

  customElements.define('tab-mega-menu', MegaMenuTab);
}
